import { type FC } from "react";
import { UserCassette } from "@clientFrontend/features/scout/components/UserCassette";
import { type UserInformation } from "@clientFrontend/features/scout/types";
import * as styles from "./styles.css";

type Props = {
  userInformationArray: UserInformation[];
  isShowCheckbox?: boolean;
  userStatusArray?: {
    userId: string;
    isChecked: boolean;
  }[];
  handleChangeCheckbox: (value: string) => void;
  isDisabled?: boolean;
  isShadow?: boolean;
  isShowScoutNavigation: boolean;
  isHiddenInitialValueArray?: boolean[];
  hiddenScoutUrl?: string;
};

export const Cassettes: FC<Props> = ({
  userInformationArray,
  isShowCheckbox,
  userStatusArray,
  handleChangeCheckbox,
  isDisabled,
  isShadow,
  isShowScoutNavigation,
  isHiddenInitialValueArray,
  hiddenScoutUrl,
}) => {
  return (
    <>
      {userInformationArray.map((userInformation, index) => {
        const isHiddenInitialValue = isHiddenInitialValueArray?.[index];
        return (
          // eslint-disable-next-line react/no-array-index-key
          <div className={styles.cassetteOuter} key={index}>
            <UserCassette
              userInformation={userInformation}
              isShowCheckbox={isShowCheckbox}
              userStatus={userStatusArray && userStatusArray[index]}
              handleChangeCheckbox={handleChangeCheckbox}
              isDisabled={isDisabled}
              isShadow={isShadow}
              isShowScoutNavigation={isShowScoutNavigation}
              isHiddenInitialValue={isHiddenInitialValue}
              hiddenScoutUrl={hiddenScoutUrl}
            />
          </div>
        );
      })}
    </>
  );
};
